'use strict';

/**
 * @desc return a truncated version of a string
 * @example <span>{{ 'your long string' | trunc: 10 }}</span>
 */

angular
  .module('cdPay.filters')
  .filter(
    'trunc',
    (_) => (input, count) => _.truncate(input, { length: count })
  );
